/**
 * ConnectorConnectedPage — where a connector's sign-in popup lands (item
 * 65A): the shared browser-bound landing (components/oauth/OAuthLandingPage)
 * with the connector wording. Tenant-less and session-less on purpose
 * (routing/popupLandings.ts).
 */

import { ApiOutlined } from '@ant-design/icons';
import { useLanguage } from '@/hooks/useLanguage';
import { OAuthLandingPage, type LandingStatus } from '@/components/oauth/OAuthLandingPage';
import '@/modules/cloud-storage/components/GoogleAccessPrompt.css';

const OUTCOMES = ['connected', 'declined', 'not_available', 'invalid_state', 'error'] as const;

export function ConnectorConnectedPage() {
  const { t } = useLanguage();
  return (
    <OAuthLandingPage
      icon={<ApiOutlined />}
      outcomes={OUTCOMES}
      title={(status: LandingStatus, name: string) =>
        t(`myConnectors.landing.${status}`, { name: name || t('myConnectors.landing.theService') })}
      closeHint={t('myConnectors.landing.close')}
      testId="connector-connected"
    />
  );
}
